import React from 'react';
import { Label, makeStyles } from '@hummingbirdtechgroup/wings-ui';
const RADIO_BUTTON_HEIGHT = 20;
const useStyles = makeStyles(({ palette, spacing }) => ({
    input: {
        display: 'none',
        '&:checked + label:before': {
            backgroundColor: palette.secondary.main,
        },
        '&:disabled + label:before': {
            borderColor: palette.grey.main,
            backgroundColor: palette.action.disabledBackground,
        },
        '&:disabled&:checked + label:before': {
            backgroundColor: palette.grey.main,
        },
    },
    label: {
        position: 'relative',
        paddingLeft: RADIO_BUTTON_HEIGHT + spacing(1),
        cursor: 'pointer',
        '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: '50%',
            width: RADIO_BUTTON_HEIGHT,
            height: RADIO_BUTTON_HEIGHT,
            border: `1px solid ${palette.secondary.main}`,
            backgroundColor: palette.background.paper,
        },
    },
}));
function RadioButton(props) {
    const { id, className = '', name, label, checked = false, value, onChange = () => undefined, disabled = false, } = props;
    const inputId = id || value;
    const inputName = name || value;
    const classes = useStyles();
    return (React.createElement("div", { className: className },
        React.createElement("input", { type: "radio", id: inputId, className: classes.input, key: `input-${name}`, name: inputName, checked: checked, value: value, onChange: onChange, disabled: disabled }),
        React.createElement(Label, { className: classes.label, htmlFor: inputId, variant: "body2" }, label)));
}
export default RadioButton;
//# sourceMappingURL=RadioButton.js.map